import FootballState from "../../../../../sports/football/state/football-state";
import DownType from "../../../../../sports/football/enums/down-type";
import { FragmentSerializer } from "./FragmentSerializer";

export class PenaltyFragmentSerializer extends FragmentSerializer {
    getPenaltyStates() {
        return [
            FootballState.PlayPenalty,
            FootballState.Penalty,
            FootballState.PlayPenaltySecondPenalty,
            FootballState.SecondPenalty
        ];
    }

    applicable(fragment) {
        return (
            this.getPenaltyStates().some(
                (s) => s === fragment.associatedState
            ) &&
            !!fragment.penaltyType &&
            !!fragment.team
        );
    }

    getRawFragment(play, serializationContext, penaltyFragment) {
        let rawPlay = "";

        // TODO: Check penalties that are parts of plays
        const { penaltyType, team } = penaltyFragment;
        const acceptedStates = [
            FootballState.PlayPenaltyPenaltyAccepted,
            FootballState.PenaltyAccepted
        ];
        const declinedStates = [
            FootballState.PlayPenaltyPenaltyDeclined,
            FootballState.PenaltyDeclined
        ];
        const offSettingStates = [
            FootballState.PlayPenaltyOffsetting,
            FootballState.Offsetting,
            FootballState.SecondOffsetting
        ];

        const penaltyFragments = play.getFragmentsBetween(
            penaltyFragment,
            this.getPenaltyStates()
        );

        const accepted = penaltyFragments.find((f) =>
            acceptedStates.some((s) => s === f.associatedState)
        );
        const declined = penaltyFragments.find((f) =>
            declinedStates.some((s) => s === f.associatedState)
        );
        const offsetting = penaltyFragments.find((f) =>
            offSettingStates.some((s) => s === f.associatedState)
        );

        const penaltyResultCode =
            accepted?.code || declined?.code || offsetting?.code;

        const fieldPosition = play.getEndFieldPosition();
        const teamSide = this.resolveTeam(serializationContext, {
            teamId: team.id
        });
        const formattedFieldPosition = this.resolveFormattedFieldPosition(
            serializationContext,
            fieldPosition
        );

        let values = [
            teamSide,
            penaltyType.code.replaceAll(" ", "_"),
            penaltyResultCode
        ];

        if (accepted) {
            const { downType, causedBy } = accepted;
            const dt = downType?.code || DownType.Normal.code;
            values = [
                ...values,
                this.resolveUniform(serializationContext, causedBy),
                formattedFieldPosition,
                dt
            ];
        }

        rawPlay = `PEN:${values.join()}`;

        return rawPlay;
    }
}
